import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOMRESTAPIENDPOINTOPTIONS from "resources/img/zoom_rest_api_endpoint_options.png";
import ZOOMSERVERSDKAUTHENTICATIONFLOW from "resources/img/zoom_server_sdk_authentication_flow.png";
import ZOOMCOMPAT from "resources/img/zoom_compat_matrix.jpg";
import SERVER_ARCHITECTURE_AND_DATA_FLOW from "resources/img/zoom_server_architecture_and_data_flow.png";
import SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE from "resources/img/zoom_server_dedicated_and_cloud_architecture.png";
import SERVER_CONSOLE_AND_COMPAT from "resources/img/server-console-and-compat.png";

export default React.createClass({
  displayName: "zoom-configuration-options",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="home">FaceTec Server Dashboard</h2>
                </div>
                <p>This guide discusses topics related to the FaceTec Server Dashboard.  <a href="https://www.youtube.com/watch?v=hDGL3ie7UbY&feature=youtu.be" target="_blank">Click Here</a> to see an overview of the features and functionality.</p>
                <hr/>
              </section>
              
              <section>
                <h3 id="introduction">Introduction</h3>
                <p>The FaceTec Server Dashboard is a web GUI that shows FaceTec SDK Usage from your Users as they perform Liveness Checks, Enrollments, Authentications, Photo ID Matches, and Age Checks.  The FaceTec Server Dashboard allows you to audit performance, create and search fraud lists, and monitor the performance of your App.</p>

                <hr />

                <h3 id="requirements">Requirements</h3>
                <p>The FaceTec Server Dashboard is a closed-source Web App and is prescriptive in its implementation.  You must use a compatibile database and file hosting technology and you must use FaceTec Standard Server.</p>
                <p>The initial release of FaceTec Server Dashboard requires MongoDB, but future versions will include support for additional database and file storage mechanisms.</p>

                <hr />

                <h3 id="stored-data">Stored Data</h3>
                <p>The FaceTec Server Dashboard shows results of FaceTec SDKs interactions from your Users.  This is achieved by storing metadata for the User Interaction by FaceTec Server.</p>
                <p>Watching the <a href="https://www.youtube.com/watch?v=hDGL3ie7UbY&feature=youtu.be" target="_blank">FaceTec Server Dashboard Overview Video</a> is the best way to get a feel for the types of data that is stored in your database.</p>
                <p>Data Stored by FaceTec Server and FaceTec Server Dashboard:</p>
                <ul>
                  <li><p>FaceTec 3D FaceMaps</p></li>
                  <li><p>2D Reference Images (Audit Trail Images)</p></li>
                  <li><p>For Photo ID Match, ID Photo Fronts and Backs</p></li>
                  <li><p>User Interaction Metadata - Date, IP, Platform and Device Model Information, Versions, Match Levels, Liveness Results, Age Estimates, etc.</p></li>
                </ul>
                <hr />

                <h3 id="architecture">Architecture</h3>
                <p>The FaceTec Server Dashboard is a deployable web app that lives inside of your private cloud/servers.</p>
                <br />
                <br />
                <p style={{textAlign: "center"}}><img src={SERVER_CONSOLE_AND_COMPAT}  width="85%" style={{maxWidth: '1300px'}} /></p>

                <hr />

                <h3 id="mongodb-best-practices">MongoDB Best Practices</h3>
                <p>MongoDB has an excellent guide regarding best practices <a href="https://www.mongodb.com/blog/post/performance-best-practices-hardware-and-os-configuration" target="_blank">posted here</a> and in <a href="https://docs.mongodb.com/manual/" target="_blank">the MongoDB Manual</a>.</p>

                <hr />

                <h3 id="supported-technologies">Supported Technologies</h3>
                <p>Currently supported:</p>
                <ul>
                  <li><p>MongoDB</p></li>
                </ul>
                <p>Planned support:</p>
                <ul>
                  <li><p>SQL</p></li>
                  <li><p>S3</p></li>
                  <li><p>Dynamo</p></li>
                  <li><p>RDS/Aurora</p></li>
                </ul>

                <hr />

                <h3 id="security">Security</h3>
                <p>The FaceTec Server Dashboard is hosted in your servers and you are responsible for securing access to the Web App and endpoints.  This can be done via network security rules and whitelisting.</p>
              </section>

              <SDKSidebar menuType="main" title="Server Dashboard"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-server-console.jsx